export const endPoint = process.env.REACT_APP_API_ENDPOINT;

// export const endPoint = "https://subbannayyalab.org";

const BASE_URL = `${endPoint}/api/`;
export const API_ENDPOINTS = {
  BASE_URL,
  GET_BIO_PROCESS_API: `${BASE_URL}get_bio_process/`,
  GET_BIO_PROCESS_DATA_API: `${BASE_URL}get_bio_process_data/`,
  GET_REGISTER_API: `${BASE_URL}user_register/`,
  GET_EMAIL_VERIFY_API: `${BASE_URL}verify-email/`,
  GET_LOGIN_API: `${BASE_URL}login/`,
  GET_LOGOUT_API: `${BASE_URL}logout/`,
  PASSWORD_RESET_REQUEST_API: `${BASE_URL}password-reset/request/`,
  PASSWORD_RESET_VERIFY_API: `${BASE_URL}password-reset/verify/`,
  PASSWORD_RESET_API: `${BASE_URL}password-reset/reset/`,
};
